// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"59d39f64","39":"3483d044","52":"f37f93e8","116":"8c5c9175","191":"46148e3e","270":"3dd3fcfe","383":"e00afa2d","405":"33a09c0f","439":"604679a8","459":"23bc56db","869":"d5c1971a","945":"b7163c77"}[chunkId] + ".chunk.js";
};